/**
 * 业务枚举的统一展示标签 (i18n 感知)。
 *
 * 之前同一个 decision_type 在 ReportView 译成 买入/观望/卖出,
 * 在 History/Batch 裸显 buy/sell/hold; confidence_level / 任务状态同理。
 * 所有视图一律经由这里取标签。
 */
import { useI18nLite } from '@/composables/useI18n'

const { t } = useI18nLite()

export function decisionLabel(v: string | null | undefined): string {
  switch ((v || '').toLowerCase()) {
    case 'buy': return t('enum.decision.buy')
    case 'sell': return t('enum.decision.sell')
    case 'hold': return t('enum.decision.hold')
    default: return v || '-'
  }
}

export function confidenceLabel(v: string | null | undefined): string {
  switch ((v || '').toLowerCase()) {
    case 'high': return t('enum.confidence.high')
    case 'medium': return t('enum.confidence.medium')
    case 'low': return t('enum.confidence.low')
    default: return v || '-'
  }
}

export function statusLabel(v: string | null | undefined): string {
  switch ((v || '').toLowerCase()) {
    case 'queued': case 'pending': return t('enum.status.queued')
    case 'running': return t('enum.status.running')
    case 'completed': return t('enum.status.completed')
    case 'failed': return t('enum.status.failed')
    case 'ready': return t('enum.status.ready')
    case 'evaluated': return t('enum.status.evaluated')
    case 'missing_data': return t('enum.status.missingData')
    default: return v || '-'
  }
}

export function marketLabel(v: string | null | undefined): string {
  switch ((v || '').toLowerCase()) {
    case 'cn': case 'a': return t('enum.market.cn')
    case 'hk': return t('enum.market.hk')
    case 'us': return t('enum.market.us')
    default: return v || '-'
  }
}

export function dataQualityLabel(v: string | null | undefined): string {
  switch ((v || '').toLowerCase()) {
    case 'good': return t('enum.quality.good')
    case 'degraded': return t('enum.quality.degraded')
    case 'partial': return t('enum.quality.partial')
    case 'stale': return t('enum.quality.stale')
    case 'missing': return t('enum.quality.missing')
    case 'unknown': return t('enum.quality.unknown')
    default: return v || '-'
  }
}

export function phaseLabel(v: string | null | undefined): string {
  switch ((v || '').toLowerCase()) {
    case 'pre_market': return t('enum.phase.pre_market')
    case 'intraday': return t('enum.phase.intraday')
    case 'lunch': return t('enum.phase.lunch')
    case 'near_close': return t('enum.phase.near_close')
    case 'after_hours': return t('enum.phase.after_hours')
    case 'non_trading': return t('enum.phase.non_trading')
    case 'unknown': return t('enum.phase.unknown')
    default: return v || '-'
  }
}

export function sentimentLabel(v: string | null | undefined): string {
  switch ((v || '').toLowerCase()) {
    case 'positive': return t('enum.sentiment.positive')
    case 'negative': return t('enum.sentiment.negative')
    case 'neutral': return t('enum.sentiment.neutral')
    default: return v || '-'
  }
}
